import * as yup from 'yup';

export const roles = [
  { value: 'admin', label: 'Admin' },
  { value: 'user', label: 'User' },
];

export const updateUserSchema = yup.object({
  role: yup.string().required().oneOf(['admin', 'user']),
});

export const inviteUserSchema = yup.object({
  email: yup.string().email().required('Email is required'),
  role: yup.string().required().oneOf(['admin', 'user']),
});

export function newInviteUser() {
  return {
    email: '',
    role: 'user',
  }
}